import { TourModel, useCreateTour } from 'api-hooks/tour/tour-list/tour-detail';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { SeparatorVertical } from 'components/styles';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import * as React from 'react';
import { NavigationProps } from 'types';

import TourForm from './components/form';
import { TourListFormType } from './components/form-type';

export type TourCreateParams = {
  defaultValues?: TourListFormType;
  tour?: TourModel;
};

export default function TourCreate(
  props: NavigationProps<NavigationRoutes.TourCreate>,
) {
  const { mutateAsync, error } = useCreateTour();

  const defaultValues = props.navigation.params?.defaultValues;
  const onResolve = useApprovalableEdit('tours');

  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}

      <TourForm
        {...props}
        defaultValues={defaultValues}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
